import React from 'react';

import classNames from 'classnames';

import { FlexBox } from '@eltoro-ui/components';

import './ContactEligibleTag.scss';

type ContactEligibleTagProps = {
  is_eligible: boolean;
};

export default function ContactEligibleTag({ is_eligible }: ContactEligibleTagProps) {
  const label = `${!is_eligible ? 'Not ' : ''}Eligible`;
  return (
    <FlexBox
      justifyContent="center"
      alignItems="center"
      UNSAFE_className={classNames('contact-eligibility', is_eligible && 'eligible')}
    >
      {label}
    </FlexBox>
  );
}
